export default "__VITE_ASSET__CFSAk4ZN__"